<app-select-filter [elements]="elements"
                   [filterElementProcessor]="filter"
                   [loading]="false"
                   [parentFormControlName]="parentFormControlName"
                   [parentFormGroup]="parentFormGroup"
                   (_onSingleSelectionChange)="singleSelectionChangedEvent.emit($event?.value)"
                   noEntriesFoundLabel="Aucun élément trouvé"
>
</app-select-filter>
